 
import 'leaflet-draw'

import L from 'leaflet'
import { useEffect } from 'react'

export type UseDrawControlsArgs = {
  map: L.Map | null
  isDrawControlEnabled: boolean
}

export const useDrawControls = ({ map, isDrawControlEnabled }: UseDrawControlsArgs) => {
  useEffect(() => {
    if (!map || map === null || !isDrawControlEnabled) return

    // Add Draw Control
    const drawnItems = new L.FeatureGroup()

    map.addLayer(drawnItems)

    const drawControl = new L.Control.Draw({
      draw: {
        polyline: false,
        marker: false,
        circlemarker: false,
        polygon: {
          shapeOptions: {
            color: 'black',
            clickable: false,
            weight: 1,
            opacity: 0.8,
            fillOpacity: 0.2,
          },
        },
        rectangle: {
          shapeOptions: {
            color: 'black',
            weight: 1,
            opacity: 0.8,
            fillOpacity: 0.2,
          },
        },
        circle: {
          shapeOptions: {
            color: 'black',
            weight: 1,
            opacity: 0.8,
            fillOpacity: 0.2,
          },
        },
      },
      edit: {
        featureGroup: drawnItems,
        edit: false,
      },
    })

    map.addControl(drawControl)
    map.on(L.Draw.Event.CREATED, function (e) {
      const type = e.type,
        layer = e.layer

      if (type === 'marker') {
      }

      map.addLayer(layer)
    })
  }, [map, isDrawControlEnabled])
}